import React from 'react';
import { FormatMeasure } from 'utils/format';
import { LoadSummaryCell } from 'modules/Common/Details';
import cx from 'classnames';
import { IS_TENANT } from 'tenant/config';

const StopLoad = ({
  type_pallets,
  load_type,
  real_pallets,
  total_weight,
  item_width,
  item_length,
  showCustomMeasures = true,
  className,
  extraClassName,
  reference_number,
  stop,
  ...rest
}) => {
  return (
    <div className={className} {...rest}>
      <div className={cx('stop-load', extraClassName)}>
        <div className="stop-load__load-detail">
          <div className="stop-load__summary">
            <LoadSummaryCell
              real_pallets={real_pallets}
              type_pallets={type_pallets}
              load_types={load_type}
              stops={[stop]}
            />
          </div>
          {IS_TENANT && <div>{reference_number}</div>}
          {(type_pallets === 'CUSTOM_PALLET' || load_type === 'BULK') &&
            showCustomMeasures &&
            !IS_TENANT && (
              <div className="stop-load__custom-size">
                ({<FormatMeasure value={item_width} />} × {<FormatMeasure value={item_length} />})
              </div>
            )}
          <div className="stop-load__weight">{total_weight} Kg</div>
        </div>
      </div>
    </div>
  );
};

export default StopLoad;
